module.exports = __webpack_public_path__ + "img/2020_20200118_120340.274f4e87.jpg";